import { defineMessages } from "react-intl";

import { node as abdominalDopplerUltrasound } from "src/modules/ltx/forms/phase-ii/imaging-procedures-ii/abdominalDopplerUltrasound";
import { node as angiographyIndirectPortography } from "src/modules/ltx/forms/phase-ii/imaging-procedures-ii/angiographyIndirectPortography";
import { node as ctAngiography } from "src/modules/ltx/forms/phase-ii/imaging-procedures-ii/ctAngiography";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.imaging_procedures_ii",
		defaultMessage: "Képalkotó vizsgálatok II"
	}
});

export const node: ParentNode = {
	id: "imagingProceduresIi",
	value: { type: "wizard", title: messages.title },
	children: [
		abdominalDopplerUltrasound,
		ctAngiography,
		angiographyIndirectPortography
	]
};
